import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React from "react";

const CustomDateField = ({
	label,
	error,
	variant,
	style,
	value,
	handleChange,
	isClearable,
	helperText,
	disabled,
	disablePast,
}: any) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<DatePicker
				label={label}
				value={value}
				onChange={handleChange}
				disabled={disabled}
				disablePast={disablePast || false}
				slotProps={{
					field: isClearable,
					textField: { error: error, variant: variant, style: style, helperText },
				}}
			/>
		</LocalizationProvider>
	);
};

export default CustomDateField;
